import React from 'react';

import Switch from '../../../forms/Switch';

export default function CtrTierInput() {
  return <Switch label="Include In CTR Tier Calc" name="ctrTierInput" />;
}
